import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.chat.message');
import { OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-nrich-chat-message',
template: templateSource || '',
    styles: [``],
})
export class PortalNrichChatMessageComponent implements OnInit, OnChanges {
    @Input() role: 'user' | 'assistant' | 'system' = 'user';
    @Input() content: string = '';
    @Input() isStreaming: boolean = false;
    @Input() documentId: string = '';
    @Output() pageClick = new EventEmitter<number>();

    public renderedHtml: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.renderContent();
    }

    public async ngOnChanges(changes: SimpleChanges) {
        if (changes['content']) {
            this.renderContent();
            await this.service.render();
        }
    }

    private renderContent() {
        if (this.role === 'user') {
            this.renderedHtml = this.escapeHtml(this.content);
            return;
        }
        // Assistant: markdown + page links + image markers
        let text = this.content || '';
        // [[page:N]] → page link
        text = text.replace(/\[\[page:(\d+)\]\]/g, (_, p: string) => {
            return `<a class="inline-flex items-center gap-0.5 text-indigo-600 hover:underline cursor-pointer text-xs font-medium" data-page="${p}" title="${p}페이지로 이동">📄 ${p}p</a>`;
        });
        // <nrich-img id="page-num" /> → inline image
        text = text.replace(/<nrich-img\s+id="(\d+)-(\d+)"\s*\/>/g, (_, page: string, num: string) => {
            const imgUrl = `/wiz/api/page.document.item/image?document_id=${encodeURIComponent(this.documentId)}&image_path=${encodeURIComponent(this.documentId + '/images/' + page + '/' + num + '.png')}`;
            return `<span class="inline-block my-1"><img src="${imgUrl}" alt="이미지 ${page}-${num}" class="max-w-xs rounded border" loading="lazy" onerror="this.parentElement.style.display='none'"></span>`;
        });
        // Simple markdown rendering (bold, italic, code, lists)
        this.renderedHtml = this.simpleMarkdown(text);
    }

    private simpleMarkdown(text: string): string {
        let html = text;
        // Code blocks
        html = html.replace(/```(\w*)\n([\s\S]*?)```/g, '<pre class="bg-zinc-100 rounded p-2 text-xs overflow-x-auto my-2"><code>$2</code></pre>');
        // Inline code
        html = html.replace(/`([^`]+)`/g, '<code class="bg-zinc-100 px-1 rounded text-xs">$1</code>');
        // Bold
        html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
        // Italic
        html = html.replace(/\*(.+?)\*/g, '<em>$1</em>');
        // Headers
        html = html.replace(/^### (.+)$/gm, '<div class="font-semibold text-zinc-900 mt-2 mb-1">$1</div>');
        html = html.replace(/^## (.+)$/gm, '<div class="font-semibold text-zinc-900 mt-3 mb-1 text-[15px]">$1</div>');
        // Unordered list
        html = html.replace(/^- (.+)$/gm, '<li class="ml-4 list-disc">$1</li>');
        html = html.replace(/(<li[^>]*>.*<\/li>\n?)+/g, '<ul class="my-1">$&</ul>');
        // Ordered list
        html = html.replace(/^\d+\. (.+)$/gm, '<li class="ml-4 list-decimal">$1</li>');
        // Line breaks
        html = html.replace(/\n/g, '<br>');
        return html;
    }

    private escapeHtml(text: string): string {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    public onContentClick(event: MouseEvent) {
        const target = event.target as HTMLElement;
        const pageStr = target.getAttribute('data-page');
        if (pageStr) {
            this.pageClick.emit(parseInt(pageStr, 10));
        }
    }
}

export default PortalNrichChatMessageComponent;